import { CalendarDayOfWeek } from './Datepicker.styles';

export interface DayOfWeekProps {
  label: string;
}

export const DayOfWeek = ({ label }: DayOfWeekProps) => (
  <CalendarDayOfWeek aria-label={label}>{label}</CalendarDayOfWeek>
);
